import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreatePaymentActivity } from '@melio/ap-activities';
import { useNavigate } from '@melio/platform-utils';

import { useRouter } from '@/hooks/router.hooks';
import { PayDashboardTabs } from '@/types/payDashboard.types';

export const CreatePaymentScreen = ({
  vendorId,
  deliveryMethodId,
  amountToPay,
  returnUrl,
}: {
  vendorId?: string;
  deliveryMethodId?: string;
  amountToPay?: string;
  returnUrl?: string;
}) => {
  const { replaceToPayDashboardTab } = useRouter();
  const navigate = useNavigate();

  const [search] = useSearchParams();
  const billId = search.get('billId') ?? undefined;

  const handleClose = useCallback(() => {
    if (returnUrl) {
      return navigate(returnUrl);
    }
    replaceToPayDashboardTab(PayDashboardTabs.Inbox, billId);
  }, [billId, replaceToPayDashboardTab, navigate, returnUrl]);

  const handleDone = (paymentId: string) => {
    replaceToPayDashboardTab(PayDashboardTabs.Scheduled, paymentId);
  };

  return (
    <CreatePaymentActivity
      billId={billId}
      vendorId={vendorId}
      deliveryMethodId={deliveryMethodId}
      amountToPay={amountToPay}
      onClose={handleClose}
      onDone={handleDone}
    />
  );
};
